<template>
  <v-card class="order-card" flat @click.stop="showArticles = !showArticles" :disabled="disabled">
    <div :class="{'opened': !orderCompleted, 'completed': orderCompleted}" style="padding: .5rem">
      <v-row>
        <v-col cols="12">
          <span class="order-card__title" :inner-html.prop="orderFullTag"></span>
          <span class="float-right order-card__total" :inner-html.prop="orderAmount | price(2)"></span>
          <br />
          <span class="order-card__title" :inner-html.prop="orderSequenceNumber"></span>
        </v-col>
      </v-row>
    </div>
    <!-- <h3 class="orderNotification" v-if="showArticles">NAROČILO - {{order.moniker}}</h3> -->
    <transition name="slide" v-if="showArticles">
      <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Količina
                </th>
                <th class="text-left" v-if="!isMobile && !isSmallTablet">
                  Ime artikla
                </th>
                <th class="text-left">
                  Lokacija tiskanja
                </th>
                <th class="text-left" v-if="!isMobile && !isSmallTablet">
                  Cena
                </th>
                <th class="text-left" v-if="!isMobile && !isSmallTablet">
                  Zaključek
                </th>
                <th>
                </th>
              </tr>
            </thead>
            <tbody v-if="showArticles">
              <template v-for="(article, index) in order.articles">
                <tr :key="article.id">
                  <td>{{ article.quantity }}x</td>
                  <td>{{ article.article_name }}</td>
                  <td>{{article.print_locations[0] ? article.print_locations[0].name : 'ni določena'}}</td>
                  <td>{{article.amount | price(2)}}</td>
                  <td>
                    <v-icon>{{ appropriateIcon(article) }}</v-icon>
                  </td>
                  <td v-if="article.printed" class="text-right">
                    <ButtonActionPrint @click="''" />
                  </td>
                </tr>
                <tr v-for="(addon, index) in article.addons" :key="addon.id">
                  <td>{{ addon.quantity }}x</td>
                  <td>{{ addon.article_name }}</td>
                  <td>{{addon.print_locations[0] ? addon.print_locations[0].name  : 'ni določena'}}</td>
                  <td>{{addon.amount | price(2)}}</td>
                  <td>
                    <v-icon>{{ appropriateIcon(article) }}</v-icon>
                  </td>
                  <td v-if="addon.printed" class="text-right">
                    <ButtonActionPrint @click="''" />
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
    </transition>
  </v-card>
</template>

<script>
import ButtonActionPrint from './ButtonActionPrint'
import Vue from 'vue'

export default {
  components: {
    ButtonActionPrint
  },
  props: {
    order: {
      required: true,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      showArticles: false
    }
  },
  computed: {
    orderFullTag () {
      // return `${this.order.table_name || this.order.session_name.replace('TMPZT-','')} - ${this.order.electronic_device_name} - ${Vue.filter('sloDateTime')(this.order.start_date)}`
      return `${this.order.moniker} - ${this.order.electronic_device_name} - ${Vue.filter('sloDateTime')(this.order.start_date)}`
    },
    orderSequenceNumber () {
      return this.order.number ? `Št. naročila: ${this.order.number}` : 'ne obstaja'
    },
    orderCompleted () {
      return this.order.end_date !== null
    },
    orderAmount () {
      var articlesAmount = 0.0
      if (this.order.articles.length > 0) {
        this.order.articles.reduce((totalArticles, article) => {
          articlesAmount += parseFloat(article.amount)
          articlesAmount += article.addons.reduce((totalAddons, addon) => totalAddons + parseFloat(addon.amount), 0)
        }, 0.0)
      }
      return articlesAmount
    }
  },
  methods: {
    appropriateIcon (item) {
      if (item.reason === 1) return 'fa-xs fa-solid fa-file-invoice-dollar'
      if (item.reason === 2) return 'fa-xs fa-solid fa-eraser'
      if (item.reason === 3) return 'fa-xs fa-exchange-alt'
    },
  }
}
</script>

<style lang="scss">

.listlist {
  display: flex;
  justify-content: space-between;
}

.order-card.v-card--disabled > *:not(.v-card__progress) {
  opacity: 1;
}
</style>

<style lang="scss" scoped>

.orderNotification {
  margin: 1rem 0;
}

.order-card__details__devider {
  border-right: 2px solid #000000;
}

.list{
  position: relative;
  width: 100%;
  margin: 1rem 0;
  padding: 0;
  list-style-type: none;
  transform-origin: top;
  transition: transform .4s ease-in-out;
  overflow: hidden;
  li{
    padding: 10px;
    background: white;
    border-bottom: solid thin #eee;
    border-left: solid medium #cbc;
  }
}
.slide-enter, .slide-leave-to{
  transform: scaleY(0);
}

.opened {
  background-color: #c9c9c9a8;
}

.completed {
  background-color: #c64242;
}

.order-card {
  padding: 0 15px;
  font-size: 20px;
  border: 2px solid #EDEDED;
  transition:all 5s ease-in-out;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px !important;

  .completed {
    .order-card__details {
      color: #000;
    }
  }

  &__title {
    &.completed {
      color: #c64242;
    }
  }

  &__details {
    line-height: 20px;
    font-size: 16px;
    color: #505B75;
    &__devider {
      width: 1px;
      height: 100%;
      margin: 0 15px 0 13px;
      border-right: 2px solid #EDEDED;
    }
  }
  &__total {
    padding-right: 20px;
    font-size: 25px;
    font-weight: bold;
    &.completed {
      color: #c64242;
    }
    &.opened {
      color: green;
    }
  }
  .commands {
    margin-right: 20px;
  }
}
</style>
